<template>
  <div class="page" ref="activity_scroll" @scroll="activityScroll">
    <img class="top_img" :src="cdnUrl+'eppendorf/newSpecial_top_bg1.jpg'" alt="">
    <div class="box" v-if="list2.length>0">
        <img class="bg1" :src="cdnUrl+'eppendorf/newSpecial_box_bg.png'" alt="">
        <div class="title_box">
            <img class="tit_icon" :src="cdnUrl+'eppendorf/title_icon.png'" alt="">
            <div class="title">新品专区</div>
        </div>
        <HorizontalScroll>
            <div class="activity">
                <img class="item_img" v-for="(item,index) in list2" :key="index" :src="cdnUrl+item.img" alt="" @click="goDetail(item)">
            </div>
        </HorizontalScroll>
    </div>
    <div class="box" v-if="list1.length>0">
        <img class="bg2" :src="cdnUrl+'eppendorf/newSpecial_box_bg.png'" alt="">
        <div class="title_box">
            <img class="tit_icon" :src="cdnUrl+'eppendorf/title_icon.png'" alt="">
            <div class="title">活动专区</div>
        </div>
        <div class="list">
            <div class="item" v-for="(item,index) in list1" :key="index" @click="goDetail(item)">
                <img class="img" :src="cdnUrl+item.img" alt="">
                <div class="info">
                    <div class="name">{{item.title}}</div>
                    <button class="btn">了解更多</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import HorizontalScroll from '@/components/HorizontalScroll.vue';
import { getNewSpecialList,action } from '@/api/newSpecial'

export default {
  components: {
    HorizontalScroll
  },
  data() {
    return {
      cdnUrl: this.$config.baseUrl.cdnUrl,
      list1:[],  //活动列表
      list2:[],  //新品列表
      page1:1,  //新品列表
      page2:1,  //活动列表
      last_page:1
    }
  },
  created() {
    this.getList(this.page1,1)
    this.getList(this.page2,2)
  },
  methods: {
    activityScroll () {
        var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
        var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
        var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
        var inadvance = 25 // 距离底部距离
        this.scrollTop = scrollTop
        if (scrollHeight - scrollTop - inadvance <= clientHeight) {
            if (this.page2 < this.last_page) {
                this.page2++
                this.getList(this.page2,2)
            }
        }
    },
    getList(page,category_id){
        var para={
            page,
            category_id,
            size:category_id==1?100:10
        }
        getNewSpecialList(para).then(res => {
            if(category_id==1){
                this.list2.push(...res.data.data)
            }else{
                this.list1.push(...res.data.data)
                this.last_page = res.data.last_page
            }
        })
    },
    goDetail(item){
        action({model:'newProducts',model_id:item.id,action:'view'})
        if(item.product_id){
            this.$router.push({
                name: 'productDetails',
                query: {
                    id:item.product_id
                }
            })
        }else{
            window.location.href = item.link
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.page{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F8F8F8;
    overflow: auto;
    .top_img{
        width: 100%;
        height: rem(182);
    }
    .box{
        width: rem(343);
        position: relative;
        margin-top: rem(20);
        background: linear-gradient( 134deg, #F8FEFF 0%, #FFFFFF 100%);
        box-shadow: 0px 2px 8px 0px rgba(28,106,121,0.16);
        border-radius: 4px;
        border: 1px solid rgba(89,193,214,0.3);
        display: flex;
        flex-direction: column;
        align-items: center;
        .bg1{
            width: rem(157);
            height: rem(88);
            position: absolute;
            top: 0;
            left: 0;
        }
        .bg2{
            width: rem(238);
            height: rem(133);
            position: absolute;
            top: 0;
            left: 0;
        }
        .title_box{
            width: rem(315);
            display: flex;
            align-items: center;
            margin-top: rem(14);
            position: relative;
            .tit_icon{
                width: rem(14);
                height: rem(14);
            }
            .title{
                height: rem(22);
                font-weight: bold;
                font-size: rem(16);
                color: #333333;
                line-height: rem(22);
                margin-left: rem(6);
            }
        }
        .activity{
            width: 100%;
            height: rem(120);
            margin-top: rem(9);
            margin-bottom: rem(23);
            overflow-x: auto;
            display: flex;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none;
            .item_img{
                width: rem(213);
                height: rem(120);
                object-fit: cover;
                margin-left: rem(14);
                border-radius: rem(10);
                flex-shrink: 0;
            }
            .item_img:last-child{
                margin-right: rem(14);
            }
        }
        .list{
            width: rem(315);
            margin-top: rem(11);
            .item{
                width: rem(315);
                height: rem(98);
                margin-bottom: rem(15);
                display: flex;
                justify-content: space-between;
                position: relative;
                .img{
                    width: rem(172);
                    height: rem(97);
                    object-fit: cover;
                    border-radius: rem(8);
                }
                .info{
                    flex: 1;
                    margin-left: rem(10);
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    justify-content: space-between;
                    .name{
                        width: 100%;
                        font-weight: bold;
                        font-size: rem(14);
                        color: #333333;
                        line-height: rem(20);
                    }
                    .btn{
                        width: rem(76);
                        height: rem(26);
                        background: linear-gradient( 270deg, #57B0F4 0%, #83D0F0 100%);
                        border-radius: rem(2);
                        border: unset;
                        color: #FFFFFF;
                        font-size: rem(12);
                    }
                }
            }
            .item:last-child{
                margin-bottom: rem(20);
            }
        }
    }
    .box:last-child{
        margin-bottom: rem(50);
    }
}
</style>